import PropTypes from 'prop-types';
import AppActions from '../../actions/app';
import EloquaActions from '../../actions/eloqua';

/* istanbul ignore next */
const mapStateToProps = (state) => {
    const {
        app,
        location,
        lead,
        eloqua
    } = state;

    const {
        address,
        serverAddressValidation,
        latLng,
        geocoderLatLng,
        partialMatch
    } = location;

    const { eloquaValue } = eloqua;

    const { fingerprint, propertyCreationProcess } = app;

    const { bedroomCount, bathroomCount } = app.lyp;

    // Null check if we don't have the estimate yet
    const locale = app.locale.canonical;

    return {
        // app
        fingerprint,
        locale,
        propertyCreationProcess,
        // lyp
        bedroomCount,
        bathroomCount,
        // lead
        newSupplier: lead.newSupplier,
        phoneNumber: lead.phoneNumber,
        phoneCountryCode: lead.phoneCountryCode,
        phoneCountryCodeDigits: lead.phoneCountryCodeDigits,
        // location
        latLng,
        serverAddressValidation,
        partialMatch,
        address,
        geocoderLatLng,
        // eloqua
        eloquaValue
    };
};

/* istanbul ignore next */
const mapDispatchToProps = (dispatch) => ({
    finishPropertyCreationProcess: () => dispatch(AppActions.finishPropertyCreationProcess()),
    startPropertyCreationProcess: (pageName) => dispatch(AppActions.startPropertyCreationProcess(pageName)),
    setCreatedPropertyTriad: (triad) => dispatch(AppActions.setCreatedPropertyTriad(triad)),
    setCreatePropertyError: (error) => dispatch(AppActions.setCreatePropertyError(error)),
    setExpediaId: (expediaId) => dispatch(AppActions.setExpediaId(expediaId)),
    setInternalUser: (isInternalUser) => dispatch(AppActions.setInternalUser(isInternalUser)),
    sendEloquaData: (data) => dispatch(EloquaActions.sendEloquaCompetitorLinkCapture(data)),
    setEloquaValue: (value) => dispatch(EloquaActions.setEloquaCompetitorLinkCaptureValue(value)),
    clearEloquaData: () => dispatch(EloquaActions.clearEloquaCompetitorLinkCaptureData())
});

const proptypes = {
    // location props
    address: PropTypes.object.isRequired,
    serverAddressValidation: PropTypes.object.isRequired,
    latLng: PropTypes.object.isRequired,
    geocoderLatLng: PropTypes.object.isRequired,
    partialMatch: PropTypes.bool.isRequired,
    // app props
    fingerprint: PropTypes.string.isRequired,
    locale: PropTypes.string.isRequired,
    // lyp props
    bedroomCount: PropTypes.number.isRequired,
    bathroomCount: PropTypes.number.isRequired,
    // lead props
    newSupplier: PropTypes.bool.isRequired,
    phoneNumber: PropTypes.string.isRequired,
    phoneCountryCode: PropTypes.string.isRequired,
    phoneCountryCodeDigits: PropTypes.string.isRequired,
    // eloqua props
    eloquaValue: PropTypes.string.isRequired,
    // pageflow props
    pageFlow: PropTypes.shape({
        next: PropTypes.func,
        navigate: PropTypes.func
    }).isRequired,
    // app actions
    setCreatedPropertyTriad: PropTypes.func.isRequired,
    setCreatePropertyError: PropTypes.func.isRequired,
    setExpediaId: PropTypes.func.isRequired,
    setInternalUser: PropTypes.func.isRequired,
    // eloqua actions
    sendEloquaData: PropTypes.func.isRequired,
    setEloquaValue: PropTypes.func.isRequired,
    clearEloquaData: PropTypes.func.isRequired
};

export {
    proptypes,
    mapStateToProps,
    mapDispatchToProps
};
